export const folderEPrescriptionMagistraliterTemplatesTableFrag = `
    id
    name
    form
    formName
    administrationRoute
    administrationRouteName
`;

export const folderEPrescriptionMagistraliterTemplateFrag = `
    ${folderEPrescriptionMagistraliterTemplatesTableFrag}
    preparationProcedure
    amount
    dosing
    paymentByEmployer
    pCheck
    ingredients {
        id
        templateId
        name
        amount
        unit
        substanceCode
        registeredMedicationCode
    }
`;
